import { render, staticRenderFns } from "./DashboardItemManager.vue?vue&type=template&id=508c38d4&"
import script from "./DashboardItemManager.vue?vue&type=script&lang=js&"
export * from "./DashboardItemManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports